import { Link } from "react-router-dom";

export const Logo = ({ className = "", showText = true, testId = "nav-brand-logo" }) => {
  return (
    <Link to="/" data-testid={testId} className={`group inline-flex items-center gap-2.5 ${className}`}>
      <span
        style={{ WebkitTextStroke: "1px currentColor" }}
        className="grid h-9 w-9 place-items-center rounded-[11px] bg-foreground font-display text-xl font-extrabold leading-none text-background shadow-sm transition-transform duration-200 group-hover:-translate-y-0.5"
      >
        M
      </span>
      {showText && (
        <span className="font-display text-xl font-extrabold tracking-tight text-foreground">
          MONOE
        </span>
      )}
    </Link>
  );
};
